import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Grade } from './GradeLabel.styled';

const GradeLabel = ({ grade }) => (
  <Wrapper data-testid="grade-label">
    <Grade>{grade}</Grade>
  </Wrapper>
);

GradeLabel.propTypes = {
  grade: PropTypes.string.isRequired,
};

export default GradeLabel;
